import { ProductViewModel } from "../product-base-model";

export class MerchandizeViewModel extends ProductViewModel {
}